import React from "react";
import Table from "../components/table/Table";
import customer_list from "../assets/JsonData/customers-list.json";

const customerTableHead = [
  "",
  "name",
  "email",
  "phone",
  "total orders",
  "total spend",
  "location",
];

const renderHead = (item, index) => <th key={index}>{item}</th>;

const renderBody = (item, index) => (
  <tr key={index}>
    <td>{item.id}</td>
    <td>{item.name}</td>
    <td>{item.email}</td>
    <td>{item.phone}</td>
    <td>{item.total_orders}</td>
    <td>{item.total_spend}</td>
    <td>{item.location}</td>
  </tr>
);
const Customers = () => {
  return (
    <>
      <div>
        <h2 className="page-header" style={{ "padding-left": "30px" }}>
          Customers
        </h2>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card__header"></div>
              <div className="card__body">
                <Table
                  limit="5"
                  headData={customerTableHead}
                  renderHead={(item, index) => renderHead(item, index)}
                  bodyData={customer_list}
                  renderBody={(item, index) => renderBody(item, index)}
                />
              </div>
              <div className="card__footer"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Customers;
